import React from 'react';
import {getMrpActiveLocation, setMrpActiveLocation} from 'utils/mrpLocation';

const labelStyle = {
	display: 'block',
	fontSize: '11px',
	fontWeight: 700,
	textTransform: 'uppercase',
	letterSpacing: '0.08em',
	marginBottom: '6px',
	opacity: 0.78,
};

export default function MrpLocationControl(props) {
	const {
		rootState,
		label = 'Location',
		note = '',
		id = 'mrp-location-control',
		selectClassName = 'form-control form-control-sm',
		wrapperClassName = '',
		wrapperStyle = null,
		labelStyleOverride = null,
		selectStyle = null,
		dark = false
	} = props;
	const {locations, location} = getMrpActiveLocation(rootState);
	const mergedLabelStyle = dark
		? {...labelStyle, color: 'rgba(255, 255, 255, 0.88)', ...(labelStyleOverride || {})}
		: {...labelStyle, ...(labelStyleOverride || {})};

	return (
		<div className={wrapperClassName} style={wrapperStyle || undefined}>
			<label htmlFor={id} style={mergedLabelStyle}>{label}</label>
			<select
				id={id}
				className={selectClassName}
				style={selectStyle || undefined}
				value={location ?? ''}
				onChange={(event) => setMrpActiveLocation(rootState, event.target.value)}
				disabled={locations.length === 0}
			>
				{locations.length === 0 ? (
					<option value="">No active locations</option>
				) : null}
				{locations.map((item) => (
					<option key={item.pkey} value={item.pkey}>
						{item.name_display || item.name}
					</option>
				))}
			</select>
			{note ? <div className="small text-muted mt-2">{note}</div> : null}
		</div>
	);
}
